"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Layout_1 = __importDefault(require("@comp/Layout"));
const posts_1 = require("@/api/posts");
const state_1 = require("@/util/state");
const setupCategoryListeners_1 = require("@/util/setupCategoryListeners");
const posts_content_1 = __importDefault(require("./posts-content"));
const PostHeader_1 = __importDefault(require("@comp/PostHeader"));
async function Posts() {
    document.title = `영범 블로그 | Posts`;
    const posts = await (0, posts_1.getFeaturedPublicPosts)();
    const categoryState = new state_1.State(new URLSearchParams(location.search).get("category") ?? "All");
    function render() {
        const selectedCategory = categoryState.getValue();
        const content = (0, posts_content_1.default)(posts, selectedCategory);
        const layoutElement = document.getElementById("app");
        if (layoutElement) {
            // 기존 내용을 비우기
            layoutElement.innerHTML = "";
            // Layout 함수로부터 반환된 HTMLElement를 추가
            const layoutContent = (0, Layout_1.default)(content, (0, PostHeader_1.default)(posts, selectedCategory));
            layoutElement.appendChild(layoutContent);
        }
        else {
            console.error("App container not found");
        }
    }
    categoryState.subscribe(render);
    render();
    (0, setupCategoryListeners_1.setupCategoryListeners)({ categoryState, render });
}
exports.default = Posts;
